module.exports = __webpack_public_path__ + "img/icon_param_active.106c3876.svg";